import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export function httpLoaderFactory(http: HttpClient) {
  return new class implements TranslateLoader {
    getTranslation(lang: string): Observable<any> {
      return http.get(`./assets/i18n/${lang}.json`);
    }
  };
}

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }),
  provideRouter(routes),
  { provide: LOCALE_ID, useValue: 'es-AR' },
  provideHttpClient(),
  importProvidersFrom(
    [TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      }})
    ])
  ]
};